import script from "./CV.vue?vue&type=script&setup=true&lang=js"
export * from "./CV.vue?vue&type=script&setup=true&lang=js"

import "./CV.vue?vue&type=style&index=0&id=250060b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250060b0"]])

export default __exports__